import { contentApi, hotelCode } from '@/infrastructure/Configuration'

export default class ComponentsService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async getSpaCard () {
    const url = `${contentApi}/hotels/${hotelCode}/spa`
    const response = await this.httpClient.get(url)

    return response.data
  }
}
